import FormspreeForm from "../components/FormspreeForm";

export default function Contact() {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 lg:grid-cols-2 gap-12" data-testid="contact-page">
      <div>
        <span className="eyebrow">Contact</span>
        <h1 className="font-display tracking-tighter text-5xl mt-4">Talk to the Fitest team.</h1>
        <p className="text-slate-300 mt-4 leading-relaxed">
          Whether you're sizing up a Gym Licence, exploring enterprise rollout,
          or have a partnership idea — drop us a note and we'll respond within one business day.
        </p>

        <dl className="mt-10 space-y-4 text-sm">
          <div>
            <dt className="text-xs uppercase tracking-widest text-slate-500">Office</dt>
            <dd className="text-slate-300">5 Brayford Square, London, E1 0SG</dd>
          </div>
          <div>
            <dt className="text-xs uppercase tracking-widest text-slate-500">Company</dt>
            <dd className="text-slate-300">Leadsopedia Limited (Company: 13145058)</dd>
          </div>
          <div>
            <dt className="text-xs uppercase tracking-widest text-slate-500">Response time</dt>
            <dd className="text-slate-300">Within 1 business day</dd>
          </div>
        </dl>
      </div>

      <FormspreeForm topic="Contact Us" />
    </div>
  );
}
